import { Component, OnInit, Inject } from '@angular/core';
//import { MessageService } from 'primeng/api';
//import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

//import { takeUntil } from 'rxjs/operators';
//import { Subject } from 'rxjs';
//import { IdbPowerPortalService } from '../../services/idb_PowerPortal/idb-power-portal.service';

@Component({
  selector: 'app-alert-message-custom',
  templateUrl: './alert-message-custom.component.html',
  styleUrls: ['./alert-message-custom.component.css']
})
export class AlertMessageCustomComponent implements OnInit {
  htmlContent: string = "";
  //ngUnsubscribe = new Subject<void>();
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) { }

  dismissAllChanged() {
    /*
    this.webWorker_PowerPortal.get_dismiss_Alerts.pipe(takeUntil(this.ngUnsubscribe)).subscribe((response) => {
      if (response) {
        this.dialogRef.close();
      }
    })
    */
  }

  ngOnInit(): void {
  }

  /*
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  */

  get getIcon() {
    switch (this.data.snackType) {
      case 'Success':
        return 'done';
      case 'Error':
        return 'error';
      case 'Warn':
        return 'warning';
      case 'Info':
        return 'info';
    }
  }
}
